import { StandardEvents } from '@shopify/events';

// Keep the native Shopify drawer, cart updates, focus trap, and checkout form.
document.addEventListener('click', event => {
  const target = event.target instanceof Element ? event.target : null;
  const cartTrigger = target?.closest('[data-pt-cart-trigger]');
  if (cartTrigger && !event.metaKey && !event.ctrlKey && !event.shiftKey && event.button === 0) {
    const drawer = document.getElementById('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      event.preventDefault();
      drawer.open();
    }
  }
  const navButton = target?.closest('.pt-nav-toggle');
  if (navButton) {
    const nav = document.getElementById(navButton.getAttribute('aria-controls'));
    const expanded = navButton.getAttribute('aria-expanded') === 'true';
    navButton.setAttribute('aria-expanded', String(!expanded));
    nav?.classList.toggle('is-open', !expanded);
  }
  if (!target?.closest('.catalog-header')) {
    document.querySelectorAll('.catalog-header details[open]').forEach(detail => detail.open = false);
  }
});
document.addEventListener('toggle', event => {
  if (!(event.target instanceof Element) || !event.target.matches('.catalog-menu[open]')) return;
  document.querySelectorAll('.catalog-menu[open]').forEach(detail => {
    if (detail !== event.target) detail.open = false;
  });
}, true);
document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  const target = event.target instanceof Element ? event.target : null;
  const detail = target?.closest('.catalog-header details[open]');
  if (detail) { detail.open = false; detail.querySelector('summary')?.focus(); }
  else {
    const navButton = document.querySelector('.pt-nav-toggle[aria-expanded="true"]');
    if (navButton) {
      navButton.setAttribute('aria-expanded', 'false');
      document.getElementById(navButton.getAttribute('aria-controls'))?.classList.remove('is-open');
      navButton.focus();
    }
  }
});
document.addEventListener(StandardEvents.cartLinesUpdate, event => {
  event.promise?.then(({cart, detail}) => {
    if (detail?.didError) return;
    const count = cart?.totalQuantity ?? cart?.item_count;
    if (typeof count !== 'number') return;
    document.querySelectorAll('[data-catalog-cart-count]').forEach(badge => {
      badge.textContent = String(count);
      badge.hidden = count === 0;
    });
  }).catch(() => {});
});
